import '.a{display:flex;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.cf{background:var(--palette-white);}.ssr-plugin'
import '.a5{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.bd{max-width:77.5rem;}.ssr-plugin'
import '.dt{justify-content:stretch;}.ssr-plugin'
import '.du{position:sticky;}.ssr-plugin'
import '.dv{top:0px;}.ssr-plugin'
import '.dw{z-index:10;}.ssr-plugin'
import '.e0{padding-block:1rem;}.ssr-plugin'
import '.e1{height:3rem;}.ssr-plugin'
import '.r{justify-content:space-between;}.ssr-plugin'
import '.cr{flex-wrap:wrap;}.ssr-plugin'
import '.e2{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bc{margin-top:2rem;}.ssr-plugin'
import '.e3{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ae b e cf"
      >
        <div className="a5 a f b e"
        >
          <div className="bd a e dt du dv dw cf"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="e0 e1 a r f cr"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="e2 a e ae bc e3 bd"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
